import * as React from 'react';
import { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { notification, Row, Col, Typography } from 'antd';
import Parameters from 'shared/parameters';
import SignupForm from './SignupForm';

import '../Login.scss';
import { useTranslation } from 'react-i18next';

import { AuthConsumer } from 'shared/contexts/AuthContext';
import API_SERVICE from '../../../services/api-service';

interface Props {
    location: any;
}

const { Title } = Typography;
export default function InsTructorRegister({ location }: Props) {
    const { t } = useTranslation();
    const [fields, setFields] = useState([] as any[]);
    const [loading, setLoading] = useState(false);

    const { from } = location.state || { from: { pathname: '/' } };

    return (
        <AuthConsumer>
            {({ isAuth, updateAuthToken }) =>
                isAuth ? (
                    <Redirect to={from}/>
                ) : (
                    <div className='container-fluid'>
                        <div className='frontend-site-login signup light-shadow p-3 p-sm-4 pl-sm-5 pr-sm-5' style={{marginTop: "10%"}}>
                     {/* <Row gutter={20} className="login">
                         <Col flex={'auto'}/>
                         <Col flex={'400px'} className="login-form-wrapper"> */}
                            <Title level={2} className="text-center">Instructor Register</Title>
                            <SignupForm
                                onChange={setFields}
                                fields={fields}
                                onRegister={async (d: any) => {
                                    setLoading(true);
                                    try {
                                        const { data } = await API_SERVICE.register({ ...d, type: 'instructor' });
                                        updateAuthToken(data.data);
                                    } catch (e) {
                                        notification.error({
                                            message: t(API_SERVICE.handleErrors(e)),
                                        });
                                    }
                                    setLoading(false);
                                }}
                                loading={loading}
                            />
                            <Row gutter={20}>
                                <Col xs={12}>
                                    <Link to="/login" className='text-blue'>
                                        <u>{t('genDict.login')}</u>
                                    </Link>
                                </Col>
                                <Col xs={12} className="text-right">
                                    <Link to="/reset-password" className='text-blue'>
                                        <u>{t('genDict.resetPassword')}</u>
                                    </Link>
                                </Col>
                            </Row>
                        {/* </Col>
                    </Row> */}
                    </div>
                </div>
                )
            }
        </AuthConsumer>
    );
}
